// "Continue with Google" for the signup / login redesign: the Google Identity Services code
// client with the identity scope only (the Search Console helper asks for webmasters access,
// which has no place on a signup page). The one-time code goes to POST /api/auth/social/exchange/,
// where the backend exchanges it with the same Web client's secret and verifies the identity.
const GSI_SRC = 'https://accounts.google.com/gsi/client'
export const GOOGLE_IDENTITY_SCOPE = 'openid email profile'

import { isAppleSignInConfigured } from './apple-identity'

const CLIENT_ID = typeof GOOGLE_OAUTH_CLIENT_ID !== 'undefined' ? GOOGLE_OAUTH_CLIENT_ID : ''
const PROVIDERS = typeof SOCIAL_LOGIN_PROVIDERS !== 'undefined' ? SOCIAL_LOGIN_PROVIDERS : ['google']

let scriptPromise = null

/** The social providers this build can offer: listed in SOCIAL_LOGIN_PROVIDERS and configured. */
export function enabledProviders () {
  return (PROVIDERS || []).filter((p) => {
    if (p === 'google') return Boolean(CLIENT_ID)
    if (p === 'apple') return isAppleSignInConfigured()
    return false
  })
}

export function isGoogleSignInAvailable () {
  return enabledProviders().includes('google')
}

function gsiReady () {
  return Boolean(window.google && window.google.accounts && window.google.accounts.oauth2)
}

export function loadGoogleIdentity () {
  if (gsiReady()) return Promise.resolve()
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = GSI_SRC
      script.async = true
      script.onload = resolve
      script.onerror = () => {
        scriptPromise = null
        reject(new Error('Failed to load the Google sign-in script'))
      }
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}

function openCodeClient (resolve, reject) {
  const client = window.google.accounts.oauth2.initCodeClient({
    client_id: CLIENT_ID,
    scope: GOOGLE_IDENTITY_SCOPE,
    ux_mode: 'popup',
    select_account: true,
    callback: (response) => {
      if (response && response.code) resolve(response.code)
      else reject(new Error((response && response.error) || 'No authorization code returned'))
    },
    error_callback: (error) => {
      const err = new Error((error && (error.message || error.type)) || 'Google sign-in failed')
      err.popupClosed = Boolean(error && error.type === 'popup_closed')
      reject(err)
    },
  })
  client.requestCode()
}

/**
 * Resolves the one-time Google authorization code. Call it straight from the click handler:
 * when the script is already loaded (pages preload it on mount) the popup opens synchronously,
 * which keeps popup blockers quiet. Rejects with error.popupClosed when the user just closed it.
 */
export function requestGoogleIdentityCode () {
  if (!CLIENT_ID) return Promise.reject(new Error('Google sign-in is not configured'))
  if (gsiReady()) return new Promise(openCodeClient)
  return loadGoogleIdentity().then(() => new Promise(openCodeClient))
}
